import styled from "styled-components";

const StyleLoadingGif = styled.img`
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  visibility: ${(props) => props.visibility};
  align-self: center;
`;

export default StyleLoadingGif;